"use client";
import useMobileDetect from "@/hooks/useMobileDetect";
import { Fragment, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { handleCardClick } from "@/utils/tools";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

type mediaCardListProps = {
  isFirstMobile?: boolean,
  list: {
    card_content: {
      "name": string,
      "h5_pic": string,
      "pc_pic": string,
      "alt_text": string,
      "link_type"?: number,
      "link"?: string,
      "open_type"?: number,
    }
  }[],
  title?: string
}
export const SinglePicture: React.FC<mediaCardListProps> = ({ isFirstMobile, list, title }) => {

  const isMobile = useMobileDetect(isFirstMobile);

  const _renderPcCardContent = () => {
    return (
      <div key="pcCardContent">
        {
          list?.map((item, index: number) => {
            return handleCardClick({ ...item?.card_content, idx: index }, (
              <div
                key={"SinglePicturePC" + index}
              >
                {item?.card_content?.pc_pic && (
                  <div className="relative w-full"
                    style={{ aspectRatio: isMobile ? '1/1' : '2880/1452' }}
                  >
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.card_content?.pc_pic}
                      alt={item?.card_content?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
              </div>
            ), isMobile)
          })
        }
      </div>
    );
  };

  const _renderMobileCardContent = () => {
    return (
      <div key="SinglePictureMobile">
        {
          list?.map((item, index: number) => {
            return handleCardClick({...item, idx: index}, (
              <div
                key={"mobileCardItem" + index}
                className="flex items-center"
              >
                {item?.card_content?.h5_pic && (
                  <div className="relative w-full"
                  style={{aspectRatio: '375/520' }}
                  >
                    <ImageWithSkeleton
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item?.card_content?.h5_pic}
                      alt={item?.card_content?.alt_text}
                      width={100}
                      height={100}
                    />
                  </div>
                )}
              </div>
            ), isMobile)
          })}
      </div>
    );
  };


  return <Fragment
    key="SinglePicture"
  >
    {isMobile ? _renderMobileCardContent() : _renderPcCardContent()}
  </Fragment>
}